module.exports = __webpack_public_path__ + "img/ealigner-box.fdc76c68.png";